<template>
  <vuestic-widget class="details-wrapper" :headerText="$t(`trip.details.title`)" :headerStyle="{ backgroundColor: confirmedBackgroundColor(tripData) }">
    <div slot="header" class="full-width" :tripId="tripData.id" >
      <div class="title-layout">
        <div class="title-left">
          <div>{{$t(`trip.details.title`)}}</div>
          <span
            aria-hidden="true"
            class="sidebar-menu-item-icon glyphicon glyphicon-pencil"
            style="margin-left: 20px; font-size: 25px;cursor:pointer"
            @click="openTrip(tripId)"
          ></span>
        </div>
        <div class="center" style="font-weight:200" v-bind:style="{ color: confirmedColor(tripData) }">{{confirmedText(tripData)}}</div>
        <div class="title-left">
          <div class="md-4" style="padding-end: 20px">{{$t('preview.status')}}:</div>
          <div v-bind:style="{ color: statusColor(tripData.status) }">{{ statusLabel(tripData.status) }}</div>
        </div>
      </div>
    </div>
    <div>
      <div class="va-row flex">
        <div class="flex md6">
          <div class="va-row">
            <span class="flex">{{$t('trip.details.destination')}}:</span>
            <span class="flex title bold table-body filters-page__table-heading">{{tripData.title}}</span>
          </div>
          <div class="va-row">
            <span class="flex">{{$t('general.from')}}</span>
            <span class="flex bold">{{startDateAsString}}</span>
            <span class="flex">{{$t('general.to')}}</span>
            <span class="flex bold">{{endDateAsString}}</span>
          </div>
          <div class="va-row">
            <span class="flex">{{$t('general.price')}}:</span>
            <span class="flex bold">{{tripData.price}}</span>
            <span class="flex pl-0">{{ $t(`general.currency.${tripCurrency}.long`) }}</span>
          </div>
          <div class="va-row">
            <div class="flex">
              <button
                class="btn btn-secondary btn-micro pull-left"
                @click="goToAddTraveller()"
              >{{$t("preview.addTraveler")}}</button>
              <button
                class="btn btn-secondary btn-micro pull-left"
                @click="goToExpenses()"
              >{{$t("preview.expenses")}}</button>
            </div>
          </div>
          <div class="va-row">
            <div class="flex md3">
              {{$t("traveller.downloadlabel")}}
            </div>
            <div class="flex md6">
              <xlsx-workbook>
                <xlsx-sheet 
                  :collection="sheet.data"
                  v-for="sheet in sheets"
                  :key="sheet.name"
                  :sheet-name="sheet.name"
                />
                <xlsx-download :filename="excelFilename"
                :extraWorkBookModifications="extraWorkBookModifications">
                  <button
                class="btn btn-secondary btn-micro pull-left"
                icon="brandico brandico-facebook"
              ><i class="fa fa-download" />{{$t("traveller.download")}}</button>
                </xlsx-download>
              </xlsx-workbook>
            </div>
          </div>
        </div>
        <div class="flex xs3 md2 offset--md2">
          <vuestic-simple-select
            class="filters-page__filter-bar pull-right"
            name="filter-type"
            id="filter-type"
            :label="$t(`general.sortBy`)"
            v-model="sortBy"
            :clearable="false"
            :options="[{key:'payment', value:$t(`trip.details.payment`)}, { key:'role', value: $t(`traveller.type`)} ]"
            option-key="value"
          />
        </div>
        <div class="flex xs6 md2">
          <vuestic-simple-select
            v-show="sortBy.key == 'payment'"
            class="filters-page__filter-bar pull-right"
            name="filter-by-payment"
            id="filter-by-payment"
            :label="$t(`trip.details.payment`)"
            v-model="paymentFilter"
            :options="[{ key: `full`, value: this.$t(`trip.details.paymentStatus.full`)},
                      { key: `partly`, value: this.$t(`trip.details.paymentStatus.partly`)},
                      { key: `none`, value: this.$t(`trip.details.paymentStatus.none`)}]"
            option-key="value"
          />
          <vuestic-simple-select
            v-show="sortBy.key == 'role'"
            class="filters-page__filter-bar pull-right"
            name="filter-by-payment"
            id="filter-by-payment"
            :label="$t(`traveller.type`)"
            title="hello"
            v-model="travelFilter"
            :options="[ { key: 'guide', value: $t(`traveller.types.guide`) },
                        { key: 'driver', value: $t(`traveller.types.driver`) },
                        { key: 'cleric', value: $t(`traveller.types.cleric`) },
                        { key: 'traveller', value: $t(`traveller.types.traveller`) }]"
            option-key="value"
          />
          <role-color-picker
            v-show="travelFilter.key == 'traveller'"
            class="va-row"
            v-model="filterColorSelected"
          ></role-color-picker>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <table class="table table-striped first-td-padding">
        <thead>
          <tr>
            <td class="filters-page__table-heading">{{ $t('general.numberSign') }}</td>
            <td class="filters-page__table-heading">{{ $t('trip.details.name') }}</td>
            <td class="filters-page__table-heading" align="center">{{ $t('traveller.place') }}</td>
            <td class="filters-page__table-heading" align="center">{{ $t('general.group') }}</td>
            <td class="filters-page__table-heading">{{ $t('general.tel') }}</td>
            <td class="filters-page__table-heading id-card">{{ $t('general.idCardShort') }}</td>
            <td
              class="filters-page__table-heading passport"
              align="center"
              v-if="!!tripData.requirePassport"
            >{{ $t('general.passport') }}</td>
            <td
              class="filters-page__table-heading"
              align="center"
              v-if="!!tripData.requireVisa"
            >{{ $t('general.visa') }}</td>
            <td
              class="filters-page__table-heading influenceSource"
              align="center"
            >{{ $t('general.influence') }}</td>
            <td
              class="filters-page__table-heading enrolmentType"
              align="center"
            >{{ $t('general.enrolment') }}</td>
            <td class="filters-page__table-heading"></td>
            <td align="center" class="filters-page__table-heading">{{ $t('traveller.payments') }}</td>
            <td align="right" class="filters-page__table-heading">{{ $t('trip.details.owes') }}</td>
          </tr>
        </thead>
        <tbody class="table-body">
          <tr
            class="participant-row"
            v-for="(participant,index) in sortedParticipants"
            v-bind:key="participant.id"
            >
            <td class="row-index">
              {{index+1}}.
              <vuestic-tooltip
                v-show="!!participant.decline"
                class="fullTooltip"
                :options="{content: `${$t('traveller.declined')}`, placement: 'bottom'}"
              ><span aria-hidden="true" class="fa fa-close"></span>
              </vuestic-tooltip>
            </td>
            <td>
              <span
                :class="{'declined': !!participant.decline }"
                class="link"
                @click="$router.push({name: 'add-traveller',query:{tripId:`${tripId}`, personId: `${participant.person.id}` }})"
              >{{ participant.person.name }}</span>
            </td>
            <td align="center">
              <span v-if="participant.busPlace != 0">{{ participant.busPlace }}</span>
            </td>
            <td align="center">
              <span v-show="(participant.role == 'traveller' || participant.role == null)&& participant.association != 'none' && participant.association != '' && participant.association != undefined"
              class="dot"
              v-bind:style="{ backgroundColor: participant.association }"></span>
              <span v-show="shouldShowRole(participant.role)">
                {{roleToLabel(participant.role)}}
              </span>

            </td>
            <td>
              <span>{{ participant.person.phone }}</span>
            </td>
            <td>
              <span v-if="!participant.person.identityCardNumber">
                <vuestic-tooltip
                  class="fullTooltip"
                  :options="{content: `${$t('warnings.noIdCard')}`, placement: 'bottom'}"
                >
                  <span
                    aria-hidden="true"
                    class="fa fa-id-card-o"
                    style="color: red;font-size: 25px;"
                  ></span>
                </vuestic-tooltip>
              </span>
              <span v-else-if="isExpiring(participant.person.identityCardExpirationDate)">
                <vuestic-tooltip
                  :options="{content: `${$t('warnings.idCardExpiring')}`, placement: 'bottom'}"
                >
                  <span
                    aria-hidden="true"
                    class="fa fa-id-card-o"
                    style="color: orange; font-size: 25px;"
                  ></span>
                  <!-- <span class="display-flex justify--center">{{$t('general.idCard')}}</span> -->
                </vuestic-tooltip>
              </span>
              <!-- <span v-else aria-hidden="true" class="fa fa-id-card-o" style="font-size: 25px;"></span> -->
              <!-- <span v-else class="warning-container border-primary">{{$t('general.idCard')}}</span> -->
            </td>
            <td
              class="passport-warning unselectable"
              align="center"
              v-if="!!tripData.requirePassport"
            >
              <span v-if="!participant.person.passportNumber">
                <vuestic-tooltip
                  class="fullTooltip"
                  :options="{content: `${$t('warnings.noPassport')}`, placement: 'bottom'}"
                >
                  <span
                    aria-hidden="true"
                    class="va-icon entypo entypo-book-open"
                    style="color: red; font-size: 30px;"
                  ></span>
                </vuestic-tooltip>
              </span>
              <span v-else-if="isExpiring(participant.person.passportExpirationDate)">
                <vuestic-tooltip
                  :options="{content: `${$t('warnings.passportExpiring')}`, placement: 'bottom'}"
                >
                  <span
                    aria-hidden="true"
                    class="va-icon entypo entypo-book-open"
                    style="color: orange; font-size: 30px;"
                  ></span>
                </vuestic-tooltip>
              </span>
            </td>
            <!-- -->
            <td
              class="unselectable"
              align="center">
              {{influenceSourceToLabel(participant.influenceSource)}}
            </td>
            <td
              class="unselectable"
              align="center">
              {{enrolmentTypeToLabel(participant.enrolmentType)}}
            </td>
            <td class="visa-warning unselectable" align="center" v-if="!!tripData.requireVisa">
              <span v-if="!participant.hasVisa">
                <vuestic-tooltip
                  :options="{content: `${$t('warnings.noVisa')}`, placement: 'bottom'}"
                >
                  <span
                    aria-hidden="true"
                    class="va-icon entypo entypo-attention"
                    style="color: red;font-size: 25px;"
                  ></span>
                </vuestic-tooltip>
              </span>
              <!-- <span v-else aria-hidden="true" class="va-icon entypo entypo-attention" style="color: orange;font-size: 25px;"></span> -->
            </td>
            <!-- <td align="right" class="unselectable">
                <span
                  class="warning-container"
                  :class="participant.paymentStatus != 'full' ? (participant.paymentStatus != 'none'? 'border-warning' :'border-danger'): 'border-primary'"
                >{{$t(`trip.details.paymentStatus.${participant.paymentStatus}`)}}</span>
            </td>-->
            <td></td>
            <td class="payments-btn-wrapper" align="center">
              <button
                class="btn btn-secondary btn-micro show-on-hover"
                @click="showPaymentDetails(participant)"
              >{{$t('traveller.payments')}}</button>
            </td>
            <td align="right">
              <span class="text-danger" v-if="!!participant.decline">{{toCurrency(participant.amountOwing - participant.singlePrice)}}</span>
              <span v-else-if="!!participant.amountOwing">{{toCurrency(participant.amountOwing)}}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="va-row">
      <div class="flex md4 offset--md8">
        <div align="right">
          <span class="mr-1">{{ $t(`trip.details.totalPaid`) }}:</span>
          <span>{{ `${totalPaidFull} / ${tripData.participants}` }}</span>
        </div>
        <div align="right">
          <span class="mr-1">{{ $t(`trip.details.totalPartyPaid`) }}:</span>
          <span>{{ `${totalPaidPartly} / ${tripData.participants}` }}</span>
        </div>
        <div align="right">
          <span class="mr-1">{{ $t(`trip.details.totalNotPaid`) }}:</span>
          <span>{{ `${totalPaidNone} / ${tripData.participants}` }}</span>
        </div>
        <div align="right">
          <span class="mr-1">{{ $t(`trip.details.totalyPaid`) }}:</span>
          <span>{{ `${toCurrency(totalyPaid)}`}}</span>
        </div>
      </div>
    </div>
    <vuestic-modal
      :noButtons="true"
      v-bind:force="true"
      ref="paymentsModal"
      :cancelClass="'none'"
      @cancel="getPaidAmount(participants.find(p=>p.id == paymentModel.id))"
    >
      <div slot="title">{{ $t('payment.header',paymentModel) }}</div>
      <payment
        :key="paymentModel.id"
        v-if="paymentModel.name!= ''"
        v-bind:tripId="+tripId"
        v-bind:tripPrice="+paymentModel.price"
        v-bind:participantId="paymentModel.id"
        v-bind:tripCurrency="paymentModel.tripCurrency"
      ></payment>
    </vuestic-modal>
  </vuestic-widget>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import VuesticWidget from "../../../vuestic-theme/vuestic-components/vuestic-widget/VuesticWidget";
import VuesticSimpleSelect from "../../../vuestic-theme/vuestic-components/vuestic-simple-select/VuesticSimpleSelect";
import { tripApi } from "../../../services/api/tripApi";
import { paymentApi } from "../../../services/api/paymentApi";
import {
  getEmptyTripData,
  isExpiringSoon,
  dateLocale,
  formatCurrency,
  convertCSVToSpreadSheetObject
} from "../../../utils";
import Payment from "../../payment/Payment.vue";
import RoleColorPicker from "../../role-color-picker/RoleColorPicker";
import VuesticPopover from "../../../vuestic-theme/vuestic-components/vuestic-popover/VuesticPopover";

import { XlsxWorkbook, XlsxSheet, XlsxDownload}  from "vue-xlsx"
//import { XlsxRead, XlsxTable, XlsxSheets, XlsxJson, XlsxWorkbook, XlsxSheet, XlsxDownload } from "../../../../node_modules/vue-xlsx/dist/vue-xlsx.es.js"
export default {
  name: "tripDetails",
  components: {
    VuesticWidget,
    VuesticSimpleSelect,
    Payment,
    VuesticPopover,
    RoleColorPicker,
    XlsxWorkbook,
    XlsxSheet,
    XlsxDownload
  },
  props: {
    tripId: String
  },
  created() {
    return Promise.all([
      tripApi.getTrip(this.tripId),
      tripApi.getAllParticipants(this.tripId)
    ])
      .then(data => {
        this.tripData = data[0];
        this.participants = data[1].sort((p1, p2) => p1.decline - p2.decline);
      })
      .then(() => {
        this.reloadPayments();
      })
      .catch(er => console.log("Error:", er));
  },
  computed: {
    startDateAsString() {
      return !!this.tripData.startDate
        ? this.tripData.startDate.format(dateLocale)
        : "";
    },
    endDateAsString() {
      return !!this.tripData.endDate
        ? this.tripData.endDate.format(dateLocale)
        : "";
    },
    filterPredicate() {
      if (this.sortBy.key == "payment")
        return p => p.paymentStatus === this.paymentFilter.key;

      if (this.sortBy.key == "role") {
        if (this.filterColorSelected != "none")
          return p => {
            return (
              p.role === this.travelFilter.key &&
              p.association == this.filterColorSelected
            );
          };
        return p => {
          return p.role === this.travelFilter.key;
        };
      }
    },
    filteredParticipants() {
      let filteredParticipants = this.participants;
      if (this.paymentFilter.key || this.travelFilter.key) {
        filteredParticipants = filteredParticipants.filter(
          this.filterPredicate
        );
      }
      return filteredParticipants;
    },
    sortedParticipants() {
      let participants = this.filteredParticipants

      participants = participants.sort((a,b) => {
        //sort by role
        let leftRole = a.role
        let rightRole = b.role
        if(leftRole == rightRole) {
        //sort by creation date
        }
        return this.roleToValue(leftRole) - this.roleToValue(rightRole)

      })

      if(this.sortByGroup) {
        let colors = []
        // participants.forEach((p) => {
        //   if(p.decline) {
        //     return
        //   }
        //   if(p.role == "traveller") {
        //     let color = 0xFFFFFF
        //     if(p.association != 'none'
        //       && p.association != ''
        //       && p.association != undefined
        //       && p.association != "") {
        //         color = p.association

        //         if(colors.indexOf(color) < 0) {
        //           colors.push(color)
        //         }
        //       }


        //   }
        // })
        let step = 1000
        let declinedValue = 1000 * step
        let groupValues = {}  
        participants.forEach((p, index) => {
          if(p.decline) {
            p.value = declinedValue
            declinedValue += 1
            return
          }
          if(p.role == "traveller") {
            let color = 0xFFFFFF
            p.value = index * step
            if(p.association != 'none'
              && p.association != ''
              && p.association != undefined
              && p.association != "") {
                color = p.association

                if(colors.indexOf(color) < 0) {
                  colors.push(color)
                  groupValues[color] = p.value + 1
                } else {
                  p.value = groupValues[color]
                  groupValues[color] += 1
                }
              }
          }
        })

        // console.log("Colors: ", colors)

        participants = participants.sort((a,b) => {
        //sort by role
        let leftRole = a.role
        let rightRole = b.role
        if(leftRole == rightRole) {
        //sort by creation date
          if(leftRole === "traveller") {
            // let l = colors.indexOf(a.association)
            // if(l < 0) {
            //   l = colors.length
            // }
            // let r = colors.indexOf(b.association)
            // if(r < 0) {
            //   r = colors.length
            // }

            return a.value - b.value
          }
        }
        return this.roleToValue(leftRole) - this.roleToValue(rightRole)

        })
      }

      return participants
    },
    // Spreadsheet generation
    sheets() {
      let headers = ["name", "latinName", "identityNumber", "phone", "role", "team", "place", "payments", "paymentsType", "paymentsDate", "identityCardNumber","passportNumber", "notes", "email", "room"].map(
        item => { return {
          label:this.$t('traveller.'+item),
          key: item
          }
        }
      )

      let rows = []
      let participants = this.sortedParticipants
      participants = participants.filter(item => !item.decline)
      let colors = []
      participants.forEach((p) => {
        if(p.role == "traveller") {
          let color = 0xFFFFFF
          if(p.association != 'none'
            && p.association != ''
            && p.association != undefined
            && p.association != "") {
              color = p.association
              if(colors.indexOf(color) < 0) {
                colors.push(color)
              }
            }
        }
      })


      participants.forEach(participant => rows.push(this.participatnToJSON(participant, colors)))
      let data = convertCSVToSpreadSheetObject(headers, rows)

      rows.sort((a, b) => a.place - b.place )
      // console.log("S:", JSON.stringify(participants))
      let dataSorted = convertCSVToSpreadSheetObject(headers, rows)

      moment.locale("bg-BG")
      let now = moment().format('LL');
      return [{ name: "Списък - " + now, data }, { name: "Aвтобус - " + now, data: dataSorted }]
    },
    tripCurrency() {
      return this.tripData.currency ? this.tripData.currency.toLowerCase() : 'bgn';
    }
  
  },
  data() {
    return {
      tripData: getEmptyTripData(),
      participants: [],
      paymentFilter: { key: "", value: "" },
      travelFilter: { key: "", value: "" },
      filterColorSelected: "none",
      sortBy: { key: "payment", value: this.$t(`trip.details.payment`) },
      paymentModel: { name: "", idNumber: "", price: 0, id: "" },
      totalPaidFull: 0,
      totalPaidNone: 0,
      totalPaidPartly: 0,
      totalyPaid: 0,
      excelFilename: "info.xlsx",
      sortByGroup: true
    };
  },
  methods: {
    participatnToJSON(participant, colors) {
      //let headers = ["name", "latinName", "phone", "payments", "identityCardNumber","passportNumber", "decline"]
      let p = {}
      p.name = participant.person.name
      p.latinName = participant.person.nameLatin
      p.phone = participant.person.phone
      p.identityCardNumber = participant.person.identityCardNumber
      p.passportNumber = participant.person.passportNumber
      p.identityNumber = participant.person.identityNumber
      p.decline = participant.decline
      p.place = participant.busPlace
      p.notes = participant.notes
      p.role = this.roleToLabelXLSX(participant.role)
      p.team = this.associationToLabelXLSX(participant.role, participant.association, colors)
      p.email = participant.person.email
      p.room = participant.roomType
      p.payments = ''
      p.paymentsType = ''
      p.paymentsDate = ''
      if (participant.paymentsSnapshot) {
        let amountInfo = ''
        let paymentsTypeInfo = ''
        let paymentsDateInfo = ''
        participant.paymentsSnapshot.forEach(
          payment => {
            amountInfo += payment.amount + ' евро\n'
            paymentsTypeInfo += this.getPaymentType(payment.paymentType) + '\n'
            paymentsDateInfo += payment.date + '\n'
          }
        )
        p.payments = amountInfo
        p.paymentsType = paymentsTypeInfo
        p.paymentsDate = paymentsDateInfo
      }
      return p
    },
    getPaymentType(type) {
      switch (type) {
        case "B":
          return this.$t("payment.type.bank");
        case "P":
          return this.$t("payment.type.pos");
        case "C":
          return this.$t("payment.type.cash");
        case "D":
          return this.$t("payment.type.protocol");
        case "V":
          return this.$t("payment.type.vaucher");
        default:
          return this.$("payment.type.other");
      }
    },
    isExpiring(expirationDate) {
      return isExpiringSoon(this.tripData.startDate, expirationDate);
    },
    shouldShowRole(role) {
      if(role == undefined || role == null || role === '' || role === 'traveller') {
        return false
      }
      return true
    },
    influenceSourceToLabel (source) {
      if (source === undefined || source == null || source === '') {
        return ''
      }
      let map = [ '',
        this.$t(`traveller.influenceSource.facebook`),
        this.$t(`traveller.influenceSource.church`),
        this.$t(`traveller.influenceSource.site`),
        this.$t(`traveller.influenceSource.recommendation`)]
      return map[source]
    },
    enrolmentTypeToLabel (type) {
      if (type === undefined || type == null || type === '') {
        return ''
      }
      let map = [ '',
        this.$t(`traveller.enrolmentType.office`),
        this.$t(`traveller.enrolmentType.site`),
        this.$t(`traveller.enrolmentType.parish`)]
      return map[type]
    },
    roleToLabel (role) {
      if(role == undefined || role == null || role === '') {
        return ""
      }
      let map = { 'guide': this.$t(`traveller.types.guide`),
        'driver': this.$t(`traveller.types.driver`),
        'cleric': this.$t(`traveller.types.cleric`),
        'traveller': this.$t(`traveller.types.traveller`)}

      return map[role]
    },
    roleToLabelXLSX(role) {
      if(role == undefined || role == null || role === '') {
        return ""
      }
      let map = { 'guide': this.$t(`traveller.types.guide`),
        'driver': this.$t(`traveller.types.driver`),
        'cleric': this.$t(`traveller.types.cleric`),
        'traveller': ''}

      return map[role]

    },
    associationToLabelXLSX(role, association, colors) {
      if(role === "traveller") {
        let i = colors.indexOf(association)
        if(i>=0) {
          return this.$t(`traveller.group`) + " " + (i + 1)
        }
      }
      return ""
    },
    roleToValue(role) {
      let roles = {
        "guide" : 2,
        "driver": 0,
        "cleric": 1,
        "traveller": 10
      }
      if(role == undefined || role == null || role === '') {
        return 10
      }
      return roles[role]
    },
    convertHex: function (color, alpha) {
      color = color.replace('#', '')
      let r = parseInt(color.substring(0, 2), 16)
      let g = parseInt(color.substring(2, 4), 16)
      let b = parseInt(color.substring(4, 6), 16)
      let result = 'rgba(' + r + ',' + g + ',' + b + ',' + alpha + ')'
      return result
    },
    backgroundColorWithAlpha (participant) {
      let color = participant.association
      let alpha = 0.19
      let travelerRole = participant.role === 'traveller' || participant.role == null
      if (color === undefined || color === '' || color === 'none' || !travelerRole) {
        alpha = 0
        color = '#FFFFFF'
      }
      return this.convertHex(color, alpha)
    },
    extraWorkBookModifications (wb) {
      let sheetName = wb.SheetNames[0];
      let sheet = wb.Sheets[sheetName];
      let colsFormatting = [{wch:30},{wch:30}, { wch: 15 }, {wch:14},{wch:14},{wch:10},{wch:6}, {wch:10}, {wch: 20}, {wch:14}, {wch:11},{wch:10},{wch:30}, {wch:25}, {wch:19}]
      sheet['!cols'] = colsFormatting

      if (wb.SheetNames.length > 1) {
        sheetName = wb.SheetNames[1]
        sheet = wb.Sheets[sheetName]
        sheet['!cols'] = colsFormatting
      }
    },
    statusLabel (status) {
      let statuses = ['', 'Активно', 'Проведено', 'Непроведено']
      return statuses[status]
    },
    statusColor (status) {
      let statuses = ['', '#ffd500', 'grey', '#ff4500']
      return statuses[status]
    },
    confirmedText (trip) {
      if (!trip) { return '' }
      if (this.totalPaidFull + this.totalPaidPartly >= trip.minimumParticipants) {
        return this.$t('trip.confirmed.confirmed')
      }
      return this.$t('trip.confirmed.unconfirmed')
    },
    confirmedColor (trip) {
      if (!trip) { return '' }
      if (this.totalPaidFull + this.totalPaidPartly >= trip.minimumParticipants) {
        return '#76eaa4'
      }
      return 'grey'
    },
    confirmedBackgroundColor (trip) {
      if (!trip) { return '' }
      if (this.totalPaidFull + this.totalPaidPartly >= trip.minimumParticipants) {
        return '#E3FAEC'
      }
      return '#ffffff'
    },
    async getPaidAmount (participant) {
      const payments = await paymentApi.allPayments(
        this.tripData.id,
        participant.id
      )

      let paidAmount = payments.reduce((t, p) => {
        return t + p.amount
      }, 0)

      this.$set(participant, 'paymentsSnapshot', payments)

      paidAmount < participant.singlePrice
        ? this.$set(
            participant,
            "amountOwing",
            participant.singlePrice - paidAmount
          )
        : this.$set(participant, "amountOwing", "");

      let status = "";
      if (paidAmount >= participant.singlePrice) {
        status = "full";
        this.totalPaidFull++;
      } else if (paidAmount == 0) {
        status = "none";
        this.totalPaidNone++;
      } else if (paidAmount > 0 && paidAmount < participant.singlePrice) {
        status = "partly";
        this.totalPaidPartly++;
      }
      this.$set(this, "totalyPaid", this.totalyPaid + paidAmount);
      this.$set(participant, "paymentStatus", status);
      this.$set(participant, "amountPaid", paidAmount);
      return paidAmount;
    },
    goToAddTraveller() {
      this.$router.push({
        name: "add-traveller",
        query: { tripId: this.tripId }
      });
    },
    goToExpenses() {
      this.$router.push({
        name: 'trip-expenses'
      });
    },
    toCurrency(amount) {
      return new Intl.NumberFormat("bg-BG", {
          style: 'currency',
          currency: this.tripCurrency
      }).format(amount);
    },
    showPaymentDetails(participant) {
      this.paymentModel = {
        name: participant.person.name,
        idNumber: participant.person.identityNumber,
        price: participant.singlePrice,
        tripCurrency: this.tripCurrency,
        id: participant.id
      };
      this.$refs.paymentsModal.open();
    },
    reloadPayments() {
      this.totalyPaid = 0
      this.participants.forEach(p => this.getPaidAmount(p));
    },
    openTrip(tripId) {
      let l = "/admin/trip/edit/" + tripId;
      this.$parent.$router.push(l);
    }
  }
};
</script>

<style lang="scss">
.details-wrapper {
  .date-title {
    font-size: 1.2rem;
    font-weight: bold;
  }

  .show-on-hover {
    visibility: hidden;
  }

  .participant-row:hover .show-on-hover {
    visibility: visible;
  }

  .table-body {
    font-size: 1.2rem;
  }

  .currency {
    display: flex;
    align-self: flex-end;
  }

  .warning-container {
    border: 2px solid;
    height: 32px;
    border-radius: 16px;
    padding: 5px 14px;
    display: -webkit-box;
    display: flex;
    justify-content: center;
    align-items: center;

    & span {
      width: 100%;
    }
  }

  .link:hover {
    cursor: pointer;
    text-decoration: underline;
  }

  .unselectable {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .display-flex {
    display: flex;
  }

  .action-hover:hover {
    cursor: pointer;
  }

  .declined {
    text-decoration: line-through red;
  }

  .row-index {
    position: relative;

    & .fa-close {
      position: absolute;
      font-size: 25px;
      right: 20%;
      color: red;
    }
  }

  .dot {
    height: 25px;
    width: 25px;
    background-color: #bbb;
    border-radius: 50%;
    display: inline-block;
  }

  .title-layout {
    display: flex;
    justify-content: space-between;
  }

  .title-left {
    display: flex;
    justify-content: space-between;
  }
  .full-width {
    width:100%
  }
}
</style>
